import { createContext, useContext, useState, useCallback } from 'react';

const PatientContext = createContext();

export const usePatient = () => {
  const context = useContext(PatientContext);
  if (!context) {
    throw new Error('usePatient must be used within a PatientProvider');
  }
  return context;
};

export const PatientProvider = ({ children }) => {
  const [patientData, setPatientData] = useState({
    id: null,
    name: null,
    activeTab: 0,
  });

  const setCurrentPatient = useCallback((id, name) => {
    setPatientData(prev => ({
      ...prev,
      id,
      name,
    }));
  }, []);

  const setActiveTab = useCallback((tab) => {
    setPatientData(prev => ({
      ...prev,
      activeTab: tab,
    }));
  }, []);

  const clearPatientData = useCallback(() => {
    setPatientData({
      id: null,
      name: null,
      activeTab: 0,
    });
  }, []);

  const value = {
    patientId: patientData.id,
    patientName: patientData.name,
    activeTab: patientData.activeTab,
    setCurrentPatient,
    setActiveTab,
    clearPatientData,
  };

  return (
    <PatientContext.Provider value={value}>
      {children}
    </PatientContext.Provider>
  );
};
